import { Component, OnInit } from '@angular/core';
import { ConfigService } from '../services/config.service';
import { Router } from '@angular/router';
import { LoginService } from 'src/app/login/login.service';

@Component({
  selector: 'app-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss']
})
export class ErrorComponent implements OnInit {

  constructor(public configService: ConfigService,
    private loginService: LoginService,
    public router: Router) { }

  ngOnInit() {
    if (sessionStorage.length) {
      this.loginService.Logout().subscribe((data: any) => {
        sessionStorage.clear();
        localStorage.clear();
      }, (error: any) => {
        sessionStorage.clear();
        localStorage.clear();
      });
    }

  }

  public RedirectToLogin() {
    if (sessionStorage.length) {
      this.loginService.Logout().subscribe((data: any) => {
        sessionStorage.clear();
        localStorage.clear();
        this.router.navigateByUrl("/Login");
      }, (error: any) => {
        sessionStorage.clear();
        localStorage.clear();
        this.router.navigateByUrl("/Login");
      });
    }
    else {
      this.router.navigateByUrl("/Login");
    }
  }

}
